import { sortBy } from 'lodash';

import { DaysOfWeekEnum } from 'src/common/external/bambi-api/routesApi';
import DayButton from 'src/common/primitives/DayButton/DayButton';

import { apiDaysOfWeekToLocalDaysMap } from '../forms/daysOfWeekMaps';

interface DayOfTheWeekCellProps {
  days: DaysOfWeekEnum[];
}

export function DayOfTheWeekCell({ days }: DayOfTheWeekCellProps) {
  return (
    <div className="flex gap-x-2">
      {orderDays(days).map((day) => (
        <DayButton
          key={day}
          day={apiDaysOfWeekToLocalDaysMap[day]}
          selected={false}
          onClick={() => {}}
        />
      ))}
    </div>
  );
}

export function orderDays(days: DaysOfWeekEnum[] | undefined) {
  if (!days) return [];

  const daysOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  return sortBy(days, (day) => daysOfWeek.indexOf(day));
}
